import React from "react"
import { Cursor } from "../../elements"
import styled from "styled-components"

const WorkCursor = ({ xValue, yValue }) => {
  return (
    <Work top={yValue} left={xValue} height="150" width="150" zIndex="999999">
      <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 145 145">
        <path
          className="st0"
          d="M72.5,18.8C72.4,18.8,72.4,18.8,72.5,18.8c-4.1,0-7.7,1.9-10,4.9c-0.5,0.7-1.5,0.9-2.3,0.5
	c-1.8-0.9-3.7-1.4-5.7-1.4c-1.8,0-3.7,0.4-5.4,1.3c0,0,0,0,0,0c-3.7,1.8-6.1,5.1-6.8,8.8c-0.2,0.9-0.9,1.5-1.8,1.5
	c-0.1,0-0.2,0-0.3,0c-3.7,0-7.3,1.6-9.8,4.7c0,0,0,0,0,0c0,0,0,0,0,0c-2.5,3.2-3.2,7.2-2.3,10.8c0.2,0.9-0.2,1.7-1,2.1
	c-3.4,1.6-6.1,4.7-7,8.6c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.9,4,0.2,7.9,2.7,10.8c0.6,0.7,0.6,1.6,0,2.3
	c-2.4,2.9-3.5,6.8-2.6,10.8c0,0,0,0.1,0,0.1c0.9,3.9,3.6,7,7.1,8.5c0.8,0.4,1.2,1.2,1,2.1c-0.9,3.7-0.1,7.7,2.4,10.8c0,0,0,0,0,0
	c0,0,0,0,0,0c0,0,0,0.1,0.1,0.1c2.5,3,6.1,4.6,9.7,4.6c0.2,0,0.3,0,0.5,0c0.9,0,1.6,0.6,1.8,1.4c0.8,3.7,3.2,7,6.9,8.7c0,0,0,0,0,0
	c0,0,0,0,0,0c1.7,0.8,3.5,1.2,5.3,1.2c2.1,0,4.1-0.5,5.9-1.5c0.7-0.4,1.6-0.2,2.2,0.5c2.3,3,5.9,4.9,9.9,4.9c0,0,0.1,0,0.1,0
	c0,0,0.1,0,0.1,0c4-0.1,7.6-2,9.8-5c0.5-0.7,1.5-0.9,2.3-0.5c1.7,0.9,3.6,1.3,5.6,1.3c1.9,0,3.8-0.4,5.6-1.3c0,0,0,0,0,0
	c0,0,0,0,0,0c3.6-1.8,6-5.2,6.7-8.9c0.2-0.9,0.9-1.5,1.8-1.5c0,0,0.1,0,0.1,0c3.7,0,7.4-1.7,9.9-4.8c0,0,0,0,0,0
	c2.5-3.2,3.2-7.2,2.2-10.9c-0.2-0.9,0.2-1.7,1-2.1c3.4-1.6,6-4.7,6.9-8.7c0,0,0,0,0,0c0,0,0,0,0,0c0.8-4-0.3-7.9-2.8-10.8
	c-0.6-0.7-0.6-1.6,0-2.3c2.4-2.9,3.4-6.9,2.4-10.8c0,0,0,0,0-0.1c0,0,0,0,0,0c-1-3.9-3.7-7-7.2-8.5c-0.8-0.4-1.3-1.2-1.1-2.1
	c0.8-3.7,0-7.7-2.5-10.8c0,0,0,0-0.1-0.1c-2.5-3-6-4.5-9.6-4.5c-0.2,0-0.4,0-0.6,0c-0.9,0-1.6-0.6-1.8-1.4c-0.8-3.7-3.3-6.9-7-8.6
	c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c-1.7-0.8-3.4-1.1-5.2-1.1c-1.9,0-3.7,0.4-5.4,1.2c-0.8,0.4-1.6,0.2-2.2-0.5
	C79.7,20.5,76.3,18.8,72.5,18.8C72.5,18.8,72.5,18.8,72.5,18.8L72.5,18.8z"
        />
        <g>
          <path
            className="st5"
            d="M64.1,55.8c0-3.2,0.1-3.7,0.2-4.2c0.5-1.3,1.5-2.1,3.2-2.1c2,0,3.1,1.1,3.3,3c0,0.1,0,0.2-0.1,0.2l-1.9,0.3
		c-0.1,0-0.2,0-0.2-0.2c-0.1-0.9-0.4-1.3-1-1.3c-0.4,0-0.8,0.2-0.9,0.6c-0.1,0.3-0.1,0.4-0.1,3.6c0,3.1,0,3.3,0.1,3.6
		c0.1,0.4,0.5,0.6,0.9,0.6s0.8-0.2,0.9-0.6c0.1-0.3,0.1-0.4,0.1-2.2c0-0.1,0-0.1-0.1-0.1h-0.8c-0.1,0-0.2-0.1-0.2-0.2v-1.6
		c0-0.1,0.1-0.2,0.2-0.2h3c0.1,0,0.2,0.1,0.2,0.2v0.5c0,3.2-0.1,3.7-0.3,4.2c-0.5,1.3-1.5,2.1-3.1,2.1c-1.6,0-2.7-0.7-3.2-2.1
		C64.1,59.5,64.1,59,64.1,55.8z"
          />
          <path
            className="st5"
            d="M73.8,60c-0.2-0.6-0.3-1.1-0.3-4.2c0-3.2,0.1-3.7,0.3-4.2c0.5-1.4,1.5-2.1,3.1-2.1s2.7,0.7,3.1,2.1
		c0.2,0.6,0.3,1.1,0.3,4.2c0,3.2-0.1,3.7-0.3,4.2c-0.5,1.3-1.5,2.1-3.1,2.1S74.2,61.4,73.8,60z M77.8,59.4c0.1-0.3,0.1-0.6,0.1-3.6
		s0-3.3-0.1-3.6c-0.1-0.3-0.4-0.6-0.9-0.6s-0.8,0.3-0.9,0.6c-0.1,0.3-0.1,0.6-0.1,3.6s0,3.3,0.1,3.6c0.1,0.3,0.4,0.6,0.9,0.6
		S77.7,59.7,77.8,59.4z"
          />
          <path
            className="st5"
            d="M37.6,72.8c0-3.2,0.1-3.7,0.2-4.2c0.4-1.3,1.4-2,3-2c2,0,3.1,1,3.2,3.1c0,0.1,0,0.2-0.2,0.2L42,70.2
		c-0.1,0-0.2,0-0.2-0.2c0-1-0.3-1.4-0.9-1.4c-0.4,0-0.7,0.2-0.8,0.6C40,69.5,40,69.7,40,72.8c0,3.1,0,3.3,0.1,3.6
		c0.1,0.4,0.4,0.6,0.8,0.6c0.6,0,0.9-0.4,0.9-1.3c0-0.1,0.1-0.2,0.2-0.2l1.9,0.3c0.1,0,0.2,0.1,0.2,0.2c-0.1,2.1-1.3,3.1-3.2,3.1
		c-1.6,0-2.6-0.7-3-2C37.6,76.6,37.6,76,37.6,72.8z"
          />
          <path
            className="st5"
            d="M46.6,66.9c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v4.6c0,0.1,0,0.1,0.1,0.1h1.7c0.1,0,0.1,0,0.1-0.1
		v-4.6c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v11.9c0,0.1-0.1,0.2-0.2,0.2h-2c-0.1,0-0.2-0.1-0.2-0.2v-4.9
		c0-0.1,0-0.1-0.1-0.1h-1.7c-0.1,0-0.1,0-0.1,0.1v4.9c0,0.1-0.1,0.2-0.2,0.2h-2c-0.1,0-0.2-0.1-0.2-0.2V66.9z"
          />
          <path
            className="st5"
            d="M56.4,66.9c0-0.1,0.1-0.2,0.2-0.2h5.3c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-3.1
		c-0.1,0-0.1,0-0.1,0.1v2.7c0,0.1,0,0.1,0.1,0.1h2.6c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-2.6c-0.1,0-0.1,0-0.1,0.1
		v2.8c0,0.1,0,0.1,0.1,0.1h3.1c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-5.3c-0.1,0-0.2-0.1-0.2-0.2V66.9z"
          />
          <path
            className="st5"
            d="M64.6,72.8c0-3.2,0.1-3.7,0.2-4.2c0.4-1.3,1.4-2,3-2c2,0,3.1,1,3.2,3.1c0,0.1,0,0.2-0.2,0.2l-1.9,0.3
		c-0.1,0-0.2,0-0.2-0.2c0-1-0.3-1.4-0.9-1.4c-0.4,0-0.7,0.2-0.8,0.6c-0.1,0.3-0.1,0.5-0.1,3.6c0,3.1,0,3.3,0.1,3.6
		c0.1,0.4,0.4,0.6,0.8,0.6c0.6,0,0.9-0.4,0.9-1.3c0-0.1,0.1-0.2,0.2-0.2l1.9,0.3c0.1,0,0.2,0.1,0.2,0.2c-0.1,2.1-1.3,3.1-3.2,3.1
		c-1.6,0-2.6-0.7-3-2C64.7,76.6,64.6,76,64.6,72.8z"
          />
          <path
            className="st5"
            d="M73.7,66.9c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v4.7l2.2-4.7c0.1-0.1,0.1-0.1,0.2-0.1h2.1
		c0.1,0,0.1,0.1,0.1,0.2l-2.4,4.8l2.8,7.1c0,0.1,0,0.2-0.1,0.2h-2.1c-0.1,0-0.2,0-0.2-0.1l-1.8-4.9l-0.7,1.5v3.3
		c0,0.1-0.1,0.2-0.2,0.2h-2c-0.1,0-0.2-0.1-0.2-0.2V66.9z"
          />
          <path
            className="st5"
            d="M88.4,75.6v-8.8c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v9c0,0.6,0.3,1.1,0.9,1.1c0.6,0,1-0.4,1-1.1v-9
		c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v8.8c0,2.3-1.3,3.5-3.3,3.5C89.7,79.1,88.4,77.9,88.4,75.6z"
          />
          <path
            className="st5"
            d="M98.1,66.9c0-0.1,0.1-0.2,0.2-0.2h1.9c0.2,0,0.3,0.1,0.3,0.2l1.9,6.4h0.1l1.8-6.4c0-0.1,0.1-0.2,0.3-0.2h1.9
		c0.1,0,0.2,0.1,0.2,0.2v11.9c0,0.1-0.1,0.2-0.2,0.2h-1.7c-0.1,0-0.2-0.1-0.2-0.2v-7.1h-0.1l-1.3,4.9c0,0.1-0.1,0.2-0.2,0.2h-1
		c-0.1,0-0.2-0.1-0.2-0.2l-1.3-4.9h-0.1v7.1c0,0.1-0.1,0.2-0.2,0.2h-1.7c-0.1,0-0.2-0.1-0.2-0.2V66.9z"
          />
          <path
            className="st5"
            d="M56.9,94c-0.2-0.6-0.3-1.1-0.3-4.2c0-3.2,0.1-3.7,0.3-4.2c0.5-1.4,1.5-2.1,3.1-2.1s2.7,0.7,3.1,2.1
		c0.2,0.6,0.3,1.1,0.3,4.2c0,3.2-0.1,3.7-0.3,4.2c-0.5,1.3-1.5,2.1-3.1,2.1S57.4,95.4,56.9,94z M60.9,93.4c0.1-0.3,0.1-0.6,0.1-3.6
		s0-3.3-0.1-3.6c-0.1-0.3-0.4-0.6-0.9-0.6s-0.8,0.3-0.9,0.6c-0.1,0.3-0.1,0.6-0.1,3.6s0,3.3,0.1,3.6c0.1,0.3,0.4,0.6,0.9,0.6
		S60.8,93.7,60.9,93.4z"
          />
          <path
            className="st5"
            d="M66.3,92.6v-8.8c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v9c0,0.6,0.3,1.1,0.9,1.1c0.6,0,1-0.4,1-1.1v-9
		c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v8.8c0,2.3-1.3,3.5-3.3,3.5C67.6,96.1,66.3,94.9,66.3,92.6z"
          />
          <path
            className="st5"
            d="M77.8,96c-0.1,0-0.2-0.1-0.2-0.2v-9.8c0-0.1,0-0.1-0.1-0.1h-1.9c-0.1,0-0.2-0.1-0.2-0.2v-1.8
		c0-0.1,0.1-0.2,0.2-0.2H82c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-1.9c-0.1,0-0.1,0-0.1,0.1v9.8c0,0.1-0.1,0.2-0.2,0.2
		H77.8z"
          />
          <path
            className="st5"
            d="M85.4,92.4l-0.5-8.5c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2l-0.5,8.5c0,0.1-0.1,0.2-0.2,0.2h-1.1
		C85.5,92.6,85.4,92.5,85.4,92.4z M85,93.7c0-0.1,0.1-0.2,0.2-0.2H87c0.1,0,0.2,0.1,0.2,0.2v2.1c0,0.1-0.1,0.2-0.2,0.2h-1.8
		c-0.1,0-0.2-0.1-0.2-0.2V93.7z"
          />
        </g>
        <g>
          <path
            className="st11"
            d="M62.1,52.8c0-3.2,0.1-3.7,0.2-4.2c0.5-1.3,1.5-2.1,3.2-2.1c2,0,3.1,1.1,3.3,3c0,0.1,0,0.2-0.1,0.2l-1.9,0.3
		c-0.1,0-0.2,0-0.2-0.2c-0.1-0.9-0.4-1.3-1-1.3c-0.4,0-0.8,0.2-0.9,0.6c-0.1,0.3-0.1,0.4-0.1,3.6c0,3.1,0,3.3,0.1,3.6
		c0.1,0.4,0.5,0.6,0.9,0.6s0.8-0.2,0.9-0.6c0.1-0.3,0.1-0.4,0.1-2.2c0-0.1,0-0.1-0.1-0.1h-0.8c-0.1,0-0.2-0.1-0.2-0.2v-1.6
		c0-0.1,0.1-0.2,0.2-0.2h3c0.1,0,0.2,0.1,0.2,0.2v0.5c0,3.2-0.1,3.7-0.3,4.2c-0.5,1.3-1.5,2.1-3.1,2.1c-1.6,0-2.7-0.7-3.2-2.1
		C62.1,56.5,62.1,56,62.1,52.8z"
          />
          <path
            className="st11"
            d="M71.8,57c-0.2-0.6-0.3-1.1-0.3-4.2c0-3.2,0.1-3.7,0.3-4.2c0.5-1.4,1.5-2.1,3.1-2.1s2.7,0.7,3.1,2.1
		c0.2,0.6,0.3,1.1,0.3,4.2c0,3.2-0.1,3.7-0.3,4.2c-0.5,1.3-1.5,2.1-3.1,2.1S72.2,58.4,71.8,57z M75.8,56.4c0.1-0.3,0.1-0.6,0.1-3.6
		s0-3.3-0.1-3.6c-0.1-0.3-0.4-0.6-0.9-0.6s-0.8,0.3-0.9,0.6c-0.1,0.3-0.1,0.6-0.1,3.6s0,3.3,0.1,3.6c0.1,0.3,0.4,0.6,0.9,0.6
		S75.7,56.7,75.8,56.4z"
          />
          <path
            className="st11"
            d="M35.6,69.8c0-3.2,0.1-3.7,0.2-4.2c0.4-1.3,1.4-2,3-2c2,0,3.1,1,3.2,3.1c0,0.1,0,0.2-0.2,0.2L40,67.2
		c-0.1,0-0.2,0-0.2-0.2c0-1-0.3-1.4-0.9-1.4c-0.4,0-0.7,0.2-0.8,0.6C38,66.5,38,66.7,38,69.8c0,3.1,0,3.3,0.1,3.6
		c0.1,0.4,0.4,0.6,0.8,0.6c0.6,0,0.9-0.4,0.9-1.3c0-0.1,0.1-0.2,0.2-0.2l1.9,0.3c0.1,0,0.2,0.1,0.2,0.2c-0.1,2.1-1.3,3.1-3.2,3.1
		c-1.6,0-2.6-0.7-3-2C35.6,73.6,35.6,73,35.6,69.8z"
          />
          <path
            className="st11"
            d="M44.6,63.9c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v4.6c0,0.1,0,0.1,0.1,0.1h1.7c0.1,0,0.1,0,0.1-0.1
		v-4.6c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v11.9c0,0.1-0.1,0.2-0.2,0.2h-2c-0.1,0-0.2-0.1-0.2-0.2v-4.9
		c0-0.1,0-0.1-0.1-0.1h-1.7c-0.1,0-0.1,0-0.1,0.1v4.9c0,0.1-0.1,0.2-0.2,0.2h-2c-0.1,0-0.2-0.1-0.2-0.2V63.9z"
          />
          <path
            className="st11"
            d="M54.4,63.9c0-0.1,0.1-0.2,0.2-0.2h5.3c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-3.1
		c-0.1,0-0.1,0-0.1,0.1v2.7c0,0.1,0,0.1,0.1,0.1h2.6c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-2.6c-0.1,0-0.1,0-0.1,0.1
		v2.8c0,0.1,0,0.1,0.1,0.1h3.1c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-5.3c-0.1,0-0.2-0.1-0.2-0.2V63.9z"
          />
          <path
            className="st11"
            d="M62.6,69.8c0-3.2,0.1-3.7,0.2-4.2c0.4-1.3,1.4-2,3-2c2,0,3.1,1,3.2,3.1c0,0.1,0,0.2-0.2,0.2l-1.9,0.3
		c-0.1,0-0.2,0-0.2-0.2c0-1-0.3-1.4-0.9-1.4c-0.4,0-0.7,0.2-0.8,0.6c-0.1,0.3-0.1,0.5-0.1,3.6c0,3.1,0,3.3,0.1,3.6
		c0.1,0.4,0.4,0.6,0.8,0.6c0.6,0,0.9-0.4,0.9-1.3c0-0.1,0.1-0.2,0.2-0.2l1.9,0.3c0.1,0,0.2,0.1,0.2,0.2c-0.1,2.1-1.3,3.1-3.2,3.1
		c-1.6,0-2.6-0.7-3-2C62.7,73.6,62.6,73,62.6,69.8z"
          />
          <path
            className="st11"
            d="M71.7,63.9c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v4.7l2.2-4.7c0.1-0.1,0.1-0.1,0.2-0.1h2.1
		c0.1,0,0.1,0.1,0.1,0.2l-2.4,4.8l2.8,7.1c0,0.1,0,0.2-0.1,0.2h-2.1c-0.1,0-0.2,0-0.2-0.1l-1.8-4.9l-0.7,1.5v3.3
		c0,0.1-0.1,0.2-0.2,0.2h-2c-0.1,0-0.2-0.1-0.2-0.2V63.9z"
          />
          <path
            className="st11"
            d="M86.4,72.6v-8.8c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v9c0,0.6,0.3,1.1,0.9,1.1c0.6,0,1-0.4,1-1.1
		v-9c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v8.8c0,2.3-1.3,3.5-3.3,3.5C87.7,76.1,86.4,74.9,86.4,72.6z"
          />
          <path
            className="st11"
            d="M96.1,63.9c0-0.1,0.1-0.2,0.2-0.2h1.9c0.2,0,0.3,0.1,0.3,0.2l1.9,6.4h0.1l1.8-6.4c0-0.1,0.1-0.2,0.3-0.2h1.9
		c0.1,0,0.2,0.1,0.2,0.2v11.9c0,0.1-0.1,0.2-0.2,0.2h-1.7c-0.1,0-0.2-0.1-0.2-0.2v-7.1h-0.1l-1.3,4.9c0,0.1-0.1,0.2-0.2,0.2h-1
		c-0.1,0-0.2-0.1-0.2-0.2l-1.3-4.9h-0.1v7.1c0,0.1-0.1,0.2-0.2,0.2h-1.7c-0.1,0-0.2-0.1-0.2-0.2V63.9z"
          />
          <path
            className="st11"
            d="M54.9,91c-0.2-0.6-0.3-1.1-0.3-4.2c0-3.2,0.1-3.7,0.3-4.2c0.5-1.4,1.5-2.1,3.1-2.1s2.7,0.7,3.1,2.1
		c0.2,0.6,0.3,1.1,0.3,4.2c0,3.2-0.1,3.7-0.3,4.2c-0.5,1.3-1.5,2.1-3.1,2.1S55.4,92.4,54.9,91z M58.9,90.4c0.1-0.3,0.1-0.6,0.1-3.6
		s0-3.3-0.1-3.6c-0.1-0.3-0.4-0.6-0.9-0.6s-0.8,0.3-0.9,0.6c-0.1,0.3-0.1,0.6-0.1,3.6s0,3.3,0.1,3.6c0.1,0.3,0.4,0.6,0.9,0.6
		S58.8,90.7,58.9,90.4z"
          />
          <path
            className="st11"
            d="M64.3,89.6v-8.8c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v9c0,0.6,0.3,1.1,0.9,1.1c0.6,0,1-0.4,1-1.1
		v-9c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2v8.8c0,2.3-1.3,3.5-3.3,3.5C65.6,93.1,64.3,91.9,64.3,89.6z"
          />
          <path
            className="st11"
            d="M75.8,93c-0.1,0-0.2-0.1-0.2-0.2v-9.8c0-0.1,0-0.1-0.1-0.1h-1.9c-0.1,0-0.2-0.1-0.2-0.2v-1.8
		c0-0.1,0.1-0.2,0.2-0.2H80c0.1,0,0.2,0.1,0.2,0.2v1.8c0,0.1-0.1,0.2-0.2,0.2h-1.9c-0.1,0-0.1,0-0.1,0.1v9.8c0,0.1-0.1,0.2-0.2,0.2
		H75.8z"
          />
          <path
            className="st11"
            d="M83.4,89.4l-0.5-8.5c0-0.1,0.1-0.2,0.2-0.2h2c0.1,0,0.2,0.1,0.2,0.2l-0.5,8.5c0,0.1-0.1,0.2-0.2,0.2h-1.1
		C83.5,89.6,83.4,89.5,83.4,89.4z M83,90.7c0-0.1,0.1-0.2,0.2-0.2H85c0.1,0,0.2,0.1,0.2,0.2v2.1c0,0.1-0.1,0.2-0.2,0.2h-1.8
		c-0.1,0-0.2-0.1-0.2-0.2V90.7z"
          />
        </g>
        <g>
          <path
            className="st0"
            id="sparkle_1"
            d="M136.8,24.4c-0.6,0.3-1.3,0.6-1.9,0.8c-6.4,1.5-6.3,1.4-7.5,8c-0.1,0.6-0.5,1.2-0.7,1.7c-0.2,0-0.4,0-0.6,0
		c-0.3-1.1-0.7-2.1-0.8-3.2c-0.4-3.8-2.5-5.7-6.2-5.8c-0.5,0-1.1-0.1-1.5-0.3c-0.4-0.1-0.6-0.6-0.9-0.8c0.3-0.2,0.5-0.6,0.8-0.7
		c1.1-0.3,2.1-0.6,3.2-0.8c2.3-0.5,3.6-1.9,4-4.2c0.2-1.2,0.4-2.3,0.7-3.4c0.1-0.4,0.5-0.7,0.8-1c0.3,0.3,0.7,0.6,0.8,0.9
		c0.3,1.1,0.5,2.1,0.8,3.2c0.5,2.4,1.9,3.7,4.3,4.1c1.6,0.2,3.2,0.6,4.8,0.9C136.7,24,136.8,24.2,136.8,24.4z"
          />
        </g>
        <g>
          <path
            className="st0"
            id="sparkle_2"
            d="M104.9,13.8c4.2-0.1,5.7-2.7,6.4-6.1c0.7,1.5,1,3.4,2.2,4.4c1.1,1,3,1.1,5.2,1.7c-2.1,0.8-4.1,0.9-5.1,2
		c-1.1,1.1-1.2,3.1-2,5.3c-0.7-1.9-0.9-3.8-1.9-4.8c-1-1.1-2.9-1.3-4.3-1.9C105.1,14.1,105,13.9,104.9,13.8z"
          />
        </g>
        <g>
          <path
            className="st0"
            id="sparkle_3"
            d="M18.3,126.2c4.2-0.1,5.7-2.7,6.4-6.1c0.7,1.5,1,3.4,2.2,4.4c1.1,1,3,1.1,5.2,1.7c-2.1,0.8-4.1,0.9-5.1,2
		c-1.1,1.1-1.2,3.1-2,5.3c-0.7-1.9-0.9-3.8-1.9-4.8c-1-1.1-2.9-1.3-4.3-1.9C18.5,126.6,18.4,126.4,18.3,126.2z"
          />
        </g>
        <g>
          <path
            className="st0"
            id="sparkle_4"
            d="M121.3,7.4c1.6,0,2.2-1,2.5-2.4c0.3,0.6,0.4,1.3,0.9,1.7c0.4,0.4,1.2,0.4,2,0.7c-0.8,0.3-1.6,0.4-2,0.8
		c-0.4,0.4-0.5,1.2-0.8,2.1c-0.3-0.8-0.3-1.5-0.7-1.9c-0.4-0.4-1.1-0.5-1.7-0.8C121.4,7.6,121.3,7.5,121.3,7.4z"
          />
        </g>
        <g>
          <path
            className="st0"
            id="sparkle_5"
            d="M12.3,119.9c1.6,0,2.2-1,2.5-2.4c0.3,0.6,0.4,1.3,0.9,1.7c0.4,0.4,1.2,0.4,2,0.7c-0.8,0.3-1.6,0.4-2,0.8
		c-0.4,0.4-0.5,1.2-0.8,2.1c-0.3-0.8-0.3-1.5-0.7-1.9c-0.4-0.4-1.1-0.5-1.7-0.8C12.4,120,12.4,119.9,12.3,119.9z"
          />
        </g>
      </svg>
    </Work>
  )
}

export default WorkCursor

const Work = styled(Cursor)`
  .st0 {
    fill: #eed36c;
  }
  .st1 {
    fill: #83c8b6;
  }
  .st2 {
    fill: #e14263;
  }
  .st3 {
    fill: none;
    stroke: #0e363d;
    stroke-width: 1.5538;
    stroke-miterlimit: 10;
  }
  .st4 {
    fill: none;
    stroke: #0e363d;
    stroke-width: 0.5614;
    stroke-miterlimit: 10;
  }
  .st5 {
    fill: #ffffff;
  }
  .st6 {
    fill: #c5934c;
  }
  .st7 {
    fill: none;
    stroke: #0e363d;
    stroke-width: 1.5091;
    stroke-miterlimit: 10;
  }
  .st8 {
    fill: #0000ff;
  }
  .st9 {
    fill: none;
    stroke: #0e363d;
    stroke-width: 0.5797;
    stroke-miterlimit: 10;
  }
  .st10 {
    fill: #e22651;
  }
  .st11 {
    fill: none;
    stroke: #0e363d;
    stroke-width: 0.75;
    stroke-miterlimit: 10;
  }
  .st12 {
    fill: none;
    stroke: #db6780;
    stroke-width: 0.75;
    stroke-miterlimit: 10;
  }
  .st13 {
    fill: #e5a13d;
  }
  .st14 {
    fill: #0d2e33;
  }
  .st15 {
    fill: #b2c4aa;
  }
  .st16 {
    fill: none;
    stroke: #e92e55;
    stroke-width: 0.75;
    stroke-miterlimit: 10;
  }
  .st17 {
    fill: none;
    stroke: #e4af53;
    stroke-width: 4;
    stroke-miterlimit: 10;
  }
  .st18 {
    fill: none;
    stroke: #10363c;
    stroke-width: 4;
    stroke-miterlimit: 10;
  }
  .st19 {
    fill: none;
    stroke: #c4d1bf;
    stroke-width: 4;
    stroke-miterlimit: 10;
  }

  #sparkle_1,
  #sparkle_2,
  #sparkle_3,
  #sparkle_4,
  #sparkle_5 {
    opacity: 0;
    animation: appear 0.5s infinite;
  }

  #sparkle_1 {
    animation-delay: 0;
  }

  #sparkle_2 {
    animation-delay: 0.1s;
  }
  #sparkle_3 {
    animation-delay: 0.15s;
  }

  @keyframes appear {
    0% {
      opacity: 0;
    }
    70% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`
